import { render, staticRenderFns } from "./AdvancedResourceLink.vue?vue&type=template&id=281233d8&"
import script from "./AdvancedResourceLink.vue?vue&type=script&lang=js&"
export * from "./AdvancedResourceLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports